var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeveralSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 70.000000 70.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525 621 c-3 -5 -2 -17 1 -26 5 -12 14 -14 34 -10 16 4 31 1 35 -5 9 -14 -13 -40 -29 -34 -23 9 -68 -16 -137 -78 l-69 -61 -54 18 -55 19 -70 -29 c-39 -15 -71 -32 -71 -37 0 -13 17 -10 79 17 l59 25 57 -20 57 -20 37 29 c20 16 50 43 66 61 17 17 42 38 56 46 25 12 28 12 41 -8 14 -21 15 -20 42 26 15 27 24 51 20 55 -18 16 -93 40 -99 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 330 l0 -270 310 0 c197 0 310 4 310 10 0 6 -111 11 -297 12 l-298 3 -3 258 c-1 160 -6 257 -12 257 -6 0 -10 -100 -10 -270z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 445 c-38 -18 -96 -56 -127 -84 l-58 -52 -57 16 c-58 16 -58 16 -138 -13 l-80 -30 -3 -81 -3 -81 276 0 275 0 0 174 c0 96 -3 177 -7 179 -5 3 -39 -10 -78 -28z m65 -52 l-1 -58 -77 -52 -78 -52 -59 15 c-55 15 -61 14 -115 -5 -31 -12 -85 -24 -119 -27 l-61 -7 0 29 c0 27 5 31 74 56 73 26 75 26 134 10 l60 -16 64 57 c50 44 140 98 176 106 1 1 2 -25 2 -56z m-2 -170 l-3 -78 -248 -3 c-220 -2 -248 -1 -254 14 -8 22 9 30 76 37 32 4 79 15 105 27 46 19 50 19 112 4 l65 -17 67 47 c36 25 70 46 75 46 4 0 7 -35 5 -77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeveralSession);
export default __webpack_public_path__ + "static/media/several_session.114e21531dabcdf351283308e897edc1.svg";
export { ForwardRef as ReactComponent };